import { sortDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default sortDuckCreator({
    ...srpDuckPreset,
    store: 'sort',
});
